import {useDispatch} from 'Provider';
import {DateTime} from 'luxon';
import {useCallback} from 'react';

import {Offer, OfferPreferences} from 'models/Offer';
import {SaveOfferPrefOpts} from 'services/api/offers/offers';
import {OffersActions} from 'store/offers/offers.reducer';
import {AdobeEvent, useTrackEvent} from './useTrackEvent';

export const useFavoriteOffer = (offer: Offer | undefined) => {
  const dispatch = useDispatch();
  const {trackAdobeEvent} = useTrackEvent();

  return useCallback(() => {
    if (!offer) {
      return null;
    }

    const payload: SaveOfferPrefOpts = {
      offerid: offer.id,
      source: offer.source,
      preference:
        offer.pref === OfferPreferences.Favorite
          ? OfferPreferences.NewOffer
          : OfferPreferences.Favorite,
      expiredate: DateTime.fromISO(offer.end).toFormat('MM/dd/yyyy'),
    };

    dispatch(OffersActions.saveOfferPref(payload));
    trackAdobeEvent({
      event: AdobeEvent.click,
      click: {
        name: 'rewards offer favorites',
      },
    });
  }, [dispatch, offer]);
};
